export default async function InsertProjectLandAndCostSpecification(senddata) {
    let url = window.RealestateService + "/api/ProjectPlotDetails/InsertProjectLandAndCostSpecification"
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "POST",
        headers: head,
        body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}